<template>
  <DialogContainer v-model="dialogObj" v-if="dialogObj.show">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="上级部门" prop="parentId">
            <custom-cascader v-model="form.parentId"></custom-cascader>
          </el-form-item>
          <el-form-item label="部门名称" prop="deptName">
            <el-input
              v-model="form.deptName"
              clearable
              autocomplete="off"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="是否为调度组" prop="dispatchGroup">
            <el-radio-group v-model="form.dispatchGroup">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, detailInfo, editInfo } from "./api";
import { addDept, editDept, getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
import { getAllTree } from "@/views/commonApi";
import CustomCascader from "@/components/CustomCascader.vue";
export default {
  name: "AddOrEdit",
  components: {
    CustomCascader,
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "添加部门",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        deptName: "",
        dutyPhone: "",
        dutyUser: "",
        parentId: "0",
        dispatchGroup: false,
      },
      rules: {
        deptName: [{ required: true, message: "部门名称不能为空" }],
        parentId: [
          { required: true, message: "上级部门不能为空", trigger: "blur" },
        ],
        deptType: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    getDetail(userId) {
      detailInfo(userId).then((res) => {
        if (res.code === 200) {
          this.form = res.data;
        }
      });
    },
    init(row, type) {
      if (type === "edit") {
        this.form = Object.assign({}, row);
        this.dialogObj.title = "编辑部门";
      } else {
        this.form.parentId = row.deptId;
        this.dialogObj.title = "新增部门";
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.deptId) {
            methodName = editDept;
          } else {
            methodName = addDept;
          }
          const par = {
            deptId: this.form.deptId,
            deptName: this.form.deptName,
            deptType: this.form.deptType,
            parentId: this.form.parentId,
            dispatchGroup: this.form.dispatchGroup,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.deptId ? "编辑成功" : "保存成功"
                );
                this.$parent.setTree();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1966ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
